var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSharedAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.39999 11.9984C2.39999 14.5445 3.41142 16.9863 5.21177 18.7867C7.01212 20.587 9.45392 21.5984 12 21.5984C14.5461 21.5984 16.9879 20.587 18.7882 18.7867C20.5886 16.9863 21.6 14.5445 21.6 11.9984C21.6 9.45236 20.5886 7.01056 18.7882 5.21021C16.9879 3.40986 14.5461 2.39844 12 2.39844C9.45392 2.39844 7.01212 3.40986 5.21177 5.21021C3.41142 7.01056 2.39999 9.45236 2.39999 11.9984V11.9984Z",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0542 7.43828L12.0542 12.2383",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0271 16.8008C12.0976 16.8008 12.1664 16.7799 12.225 16.7407C12.2836 16.7016 12.3293 16.646 12.3562 16.5809C12.3832 16.5158 12.3903 16.4441 12.3765 16.375C12.3628 16.3059 12.3288 16.2424 12.279 16.1926C12.2292 16.1428 12.1657 16.1089 12.0966 16.0951C12.0275 16.0814 11.9559 16.0884 11.8908 16.1154C11.8257 16.1424 11.77 16.188 11.7309 16.2466C11.6917 16.3052 11.6708 16.3741 11.6708 16.4445C11.6708 16.539 11.7084 16.6296 11.7752 16.6964C11.842 16.7632 11.9326 16.8008 12.0271 16.8008Z",
    fill: "#0E5CF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0271 16.8008C12.0976 16.8008 12.1664 16.7799 12.225 16.7407C12.2836 16.7016 12.3293 16.646 12.3562 16.5809C12.3832 16.5158 12.3903 16.4441 12.3765 16.375C12.3628 16.3059 12.3288 16.2424 12.279 16.1926C12.2292 16.1428 12.1657 16.1089 12.0966 16.0951C12.0275 16.0814 11.9559 16.0884 11.8908 16.1154C11.8257 16.1424 11.77 16.188 11.7309 16.2466C11.6917 16.3052 11.6708 16.3741 11.6708 16.4445C11.6708 16.539 11.7084 16.6296 11.7752 16.6964C11.842 16.7632 11.9326 16.8008 12.0271 16.8008",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSharedAlert);
export default __webpack_public_path__ + "static/media/ic-shared-alert.50e05b08c061890e92bd9a05da40b6c5.svg";
export { ForwardRef as ReactComponent };